// extracted by mini-css-extract-plugin
export var description = "NewsletterForm-module--description--41f44";
export var emailInput = "NewsletterForm-module--email-input--1bf60";
export var form = "NewsletterForm-module--form--82d88";
export var inputWrapper = "NewsletterForm-module--input-wrapper--ad9ef";
export var newsletter = "NewsletterForm-module--newsletter--805d3";
export var sendButton = "NewsletterForm-module--send-button--d9178";
export var sendButtonIcon = "NewsletterForm-module--send-button-icon--f6889";
export var sendButtonText = "NewsletterForm-module--send-button-text--83d7d";
export var title = "NewsletterForm-module--title--195c4";